const pinOnMapDarkSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
 width="127.818px" height="123.158px" viewBox="0 0 127.818 123.158" enable-background="new 0 0 127.818 123.158"
 xml:space="preserve">
<g id="Layer_1">
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
<g>
<path d="M120.085,51.137H94.763c-1.284,0-2.323,1.039-2.323,2.324c0,1.283,1.039,2.322,2.323,2.322h21.147l6.734,62.729H5.27
l7.905-62.729h21.184c1.285,0,2.323-1.039,2.323-2.322c0-1.285-1.038-2.324-2.323-2.324H9.077L0,123.158h127.818L120.085,51.137z"
/>
<path d="M61.924,88.205c-0.342,0.201-0.706,0.381-1.034,0.592c-0.511,0.33-1.011,0.676-1.501,1.033
c-1.033,0.761-1.256,2.214-0.499,3.249c0.456,0.62,1.162,0.947,1.878,0.947c0.476,0,0.957-0.146,1.372-0.448
c0.414-0.305,0.834-0.598,1.273-0.881c0.746-0.483,1.538-0.936,2.356-1.35c1.087-0.551,1.528-1.838,1.072-2.948
c0.02-0.019,0.042-0.032,0.059-0.052c4.203-4.451,18.365-21.132,24.229-48.922c1.19-5.637,1.457-11.045,0.795-16.075
C89.927,8.076,80.436,0,64.48,0C48.528,0,39.038,8.076,37.035,23.351c-0.66,5.032-0.393,10.441,0.797,16.075
C43.638,66.947,57.577,83.563,61.924,88.205z M41.643,23.957c1.703-12.991,9.174-19.308,22.84-19.308
c13.668,0,21.137,6.316,22.837,19.308c0.593,4.507,0.344,9.394-0.734,14.514c-5.271,24.981-17.841,40.833-22.103,45.643
c-4.268-4.814-16.835-20.673-22.104-45.643C41.298,33.351,41.053,28.467,41.643,23.957z"/>
<path d="M64.482,43.963c9.411,0,17.066-7.655,17.066-17.066S73.894,9.829,64.482,9.829c-9.412,0-17.067,7.656-17.067,17.067
S55.07,43.963,64.482,43.963z M64.482,14.479c6.847,0,12.419,5.57,12.419,12.42c0,6.849-5.57,12.42-12.419,12.42
c-6.85,0-12.42-5.571-12.42-12.42C52.063,20.049,57.636,14.479,64.482,14.479z"/>
<path d="M73.016,84.027c-1.255,0.266-2.055,1.5-1.787,2.758c0.232,1.092,1.197,1.838,2.271,1.838c0.159,0,0.325-0.017,0.487-0.052
c1.361-0.288,2.836-0.532,4.382-0.727c1.272-0.157,2.179-1.317,2.019-2.591c-0.158-1.275-1.308-2.195-2.59-2.019
C76.117,83.441,74.507,83.709,73.016,84.027z"/>
<path d="M85.028,84.97c0.051,1.248,1.083,2.225,2.319,2.225c0.034,0,0.067,0,0.102-0.003l4.649-0.192
c1.28-0.059,2.274-1.146,2.213-2.426c-0.058-1.285-1.251-2.286-2.425-2.217L87.25,82.55C85.967,82.604,84.973,83.686,85.028,84.97
z"/>
<path d="M52.117,95.66c-1.194,0.9-2.427,1.768-3.67,2.571c-1.076,0.7-1.383,2.138-0.684,3.216
c0.443,0.685,1.191,1.057,1.952,1.057c0.434,0,0.87-0.121,1.264-0.374c1.331-0.864,2.657-1.794,3.938-2.76
c1.022-0.774,1.227-2.23,0.456-3.255C54.599,95.1,53.146,94.886,52.117,95.66z"/>
<path d="M103.896,80.341c-0.785,0.55-1.805,0.949-3.127,1.222c-1.257,0.258-2.065,1.489-1.805,2.746
c0.228,1.1,1.194,1.854,2.274,1.854c0.154,0,0.313-0.017,0.472-0.048c1.955-0.404,3.545-1.051,4.87-1.982l0.311-0.228
c1.021-0.776,1.224-2.232,0.45-3.255c-0.774-1.023-2.229-1.223-3.254-0.451L103.896,80.341z"/>
<path d="M20.584,98.505c0.337-1.238-0.396-2.513-1.636-2.847c-1.229-0.348-2.514,0.392-2.849,1.635
c-0.292,1.078-0.466,2.18-0.522,3.264c-0.011,0.268-0.018,0.537-0.018,0.821c0.002,0.454,0.022,0.909,0.067,1.364
c0.122,1.195,1.131,2.085,2.309,2.085c0.077,0,0.156-0.005,0.239-0.012c1.276-0.132,2.204-1.271,2.077-2.548
c-0.032-0.305-0.044-0.614-0.046-0.906c0-0.194,0.007-0.386,0.016-0.576C20.259,100.033,20.379,99.264,20.584,98.505z"/>
<path d="M103.845,62.283c-1.845-0.248-3.728-0.097-5.543,0.419c-1.236,0.347-1.954,1.631-1.604,2.864
c0.288,1.024,1.22,1.693,2.232,1.693c0.212,0,0.423-0.027,0.632-0.088c1.209-0.339,2.452-0.445,3.66-0.283
c1.305,0.162,2.443-0.723,2.613-1.991C106.008,63.622,105.115,62.453,103.845,62.283z"/>
<path d="M108.468,73.791c-0.378,1.225,0.31,2.528,1.533,2.904c0.229,0.072,0.458,0.104,0.686,0.104
c0.994,0,1.911-0.638,2.219-1.638c0.229-0.738,0.372-1.488,0.426-2.237c0.012-0.192,0.019-0.387,0.019-0.581
c0-1.087-0.201-2.177-0.593-3.233c-0.446-1.206-1.792-1.814-2.985-1.371c-1.207,0.446-1.816,1.784-1.371,2.985
c0.199,0.539,0.303,1.086,0.303,1.617l-0.008,0.272C108.668,72.999,108.594,73.385,108.468,73.791z"/>
<path d="M40.613,102.599c-1.361,0.639-2.749,1.232-4.121,1.764c-1.197,0.46-1.792,1.805-1.33,3.005
c0.355,0.919,1.234,1.486,2.168,1.486c0.279,0,0.563-0.049,0.837-0.156c1.476-0.568,2.962-1.205,4.421-1.889
c1.161-0.543,1.661-1.928,1.115-3.09C43.162,102.555,41.781,102.051,40.613,102.599z"/>
<path d="M23.7,92.928c0.374,0,0.755-0.091,1.11-0.284c0.669-0.364,1.383-0.592,2.117-0.671c0.313-0.037,0.633-0.037,0.942,0.005
c1.308,0.17,2.438-0.729,2.606-1.998c0.167-1.273-0.727-2.439-1.998-2.606c-0.692-0.09-1.396-0.096-2.07-0.02
c-1.333,0.146-2.62,0.557-3.823,1.211c-1.127,0.616-1.544,2.023-0.928,3.15C22.08,92.49,22.877,92.928,23.7,92.928z"/>
<path d="M23.217,111.144c0.502,0.13,1.013,0.229,1.52,0.288c0.594,0.072,1.189,0.109,1.786,0.109c0.728,0,1.457-0.052,2.185-0.145
c1.272-0.159,2.176-1.32,2.014-2.595c-0.163-1.272-1.317-2.17-2.596-2.014c-0.938,0.12-1.886,0.148-2.824,0.034
c-0.308-0.039-0.613-0.098-0.916-0.174c-1.243-0.332-2.509,0.421-2.834,1.663C21.232,109.555,21.977,110.824,23.217,111.144z"/>
</g>
</g>
</svg>

`;

export default pinOnMapDarkSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/pinOnMapDarkSVG.js